import React, { useState, useEffect, useRef } from 'react';

import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import { useLocation } from "react-router-dom";
// import { ExcelExport } from "@progress/kendo-react-excel-export";

import Section from '../Section';
import { getArchivContentData } from '../../server/ServerFunc';
import SvgIcon from '../../CustomeComponents/SvgIcon'
import AppHeaderGlobal from '../AppHeaderGlobal';
import AppFooter from '../AppFooter';


const ArchivInfo = ({ isSeparate }) => {
  const [archivDocsList, setArchivDocsList] = useState([]);
  const [isDocExtension, setIsDocExtension] = useState(false);
  const [extensionMessage, setExtensionMessage] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [systemCode, setSystemCode] = useState("");
  // const _exportRef = useRef(null);

  const titles = {
		"dateIn": "תאריך תיוק",
		"documentDescr": "שם המסמך",
    "urlDoc": "צרופות"
	}

  const search = useLocation().search;
  
  useEffect(() => {
    const tikNumURL = new URLSearchParams(search).get("TikNum");
    const systemCodeURL = new URLSearchParams(search).get("SystemCode");
    getArchivContent(systemCodeURL, tikNumURL);
    setIsMobile(window.innerWidth < 768);
    setSystemCode(systemCodeURL);
  }, []);
  

  const getArchivContent = async (systemCode, tikNum) => {
    const archivData = await getArchivContentData(systemCode, tikNum);
    if(archivData.length > 0) {
      let isDocExtensionDwfx = false;
      for (let i = 0; i < archivData.length; i++) {
        if(archivData[i].docExtension === 'dwfx') {
          isDocExtensionDwfx = true;
          break;
        }
      }

      setIsDocExtension(isDocExtensionDwfx);
      setExtensionMessage(<div><b>לצפייה בקבצי DWFX יש להתקין תוכנה חינמית <a href='https://www.autodesk.com/products/design-review/download'>Design Review</a></b></div>)
      setArchivDocsList(archivData);
    } else {
      setArchivDocsList([]);
    }
  }

  const openDocUrl = (docUrl) => {
    window.open(`${docUrl}`,"_blank");
  }

  // const exportToExcel = () => {
	// 	if (_exportRef.current !== null) {
	// 		const tableData = _exportRef.current.props.data;
	// 		const options = _exportRef.current.workbookOptions();
	// 		const rows = options.sheets[0].rows;
  //     rows.forEach((row, i) => {
  //       if (row.type === "data") {
  //         if (tableData[i - 1].documentDate === row.cells[0].value && tableData[i - 1].documentDescr === row.cells[1].value) {
  //           row.cells[2].value = tableData[i - 1].urlDoc;
  //         }
  //       }
  //     });

	// 		_exportRef.current.save(options);
	// 	}
	// };

  const LabeledDataItem = (label, value) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
			<div className="value">{value}</div>
		</div>
	}

  const LabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], props.dataItem[props.field])}
		</td>
	}

  const SvgIconCell = (props) => {
    const data = props.dataItem;
		return <td {...props.tdProps} className="icon-cell">
			{LabeledDataItem('קישור', <SvgIcon icon={"eye"} style={{ cursor: 'pointer' }} onClick={() => openDocUrl(data.urlDoc)} />)}
		</td>
	}

  const ArchivTable = () => {
    return (
      // <ExcelExport data={archivDocsList} fileName="ארכיב אופטי.xlsx" ref={_exportRef}>
			<Grid data={archivDocsList} >
        {/* <GridToolbar>
            <SvgIcon icon={"file-exe"} title="ייצא לאקסל" onClick={exportToExcel} style={{ cursor: "pointer", marginRight: "1000px" }} />
        </GridToolbar> */}
				{/* <GridColumn field="documentDate" title={titles.documentDate} cell={LabeledCell} /> */}
				<GridColumn field="dateIn" title={titles.dateIn} cell={LabeledCell} />
				<GridColumn field="documentDescr" title={titles.documentDescr} cell={LabeledCell} />
        <GridColumn field="urlDoc" title={titles.urlDoc} cell={SvgIconCell} headerClassName={'icon-header-cell'} />
			</Grid>
      // </ExcelExport>
		)
  }

  return (
    <>
      { isSeparate && <AppHeaderGlobal /> }
      {
        systemCode === "26400046" ?
          <div style={{ margin: (!isSeparate ? "-104px 0px 0px 0px" : ""), backgroundColor: "white" }} >
            <div className="container my-3 my-lg-5">
              <Section icon={'hammer'} title={'ארכיב אופטי'} className="mt-3" >
                {
                  archivDocsList.length > 0 ?
                    <>
                      {
                        isDocExtension ?
                          <div>{extensionMessage}</div>
                          :
                          ""
                      }
                      <ArchivTable />
                    </>
                    :
                    <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
                }
              </Section>
            </div>
          </div>
          :
          <div className="container my-3 my-lg-5">
            <Section icon={'hammer'} title={'ארכיב אופטי'} className="mt-3" >
              {
                archivDocsList.length > 0 ?
                  <>
                    {
                      isDocExtension ?
                        <div>{extensionMessage}</div>
                        :
                        ""
                    }
                    <ArchivTable />
                  </>
                  :
                  <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
              }
            </Section>
          </div>
      }
      { isSeparate && <AppFooter /> }
    </>
  )
}

export default ArchivInfo